import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Sparkles, RefreshCw } from "lucide-react";
import { LangStatusIcon, shortLang } from "@/components/design/langStatus";

/** Iter 158 — Plantillas de email fuera de Diseño (reserva, post-reparación, recordatorios). */
export default function ExternalTemplatesPanel() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () => api.get("/templates/i18n/external/status").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const translate = async (code) => {
    setBusy(code);
    try {
      const r = await api.post(`/templates/i18n/external/${code}/translate-pending`);
      if (r.data.errors?.length) toast.error(r.data.errors.join(" · "));
      else toast.success(`${r.data.translated} plantilla(s) traducidas a ${shortLang(code)}`);
      await load();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };

  const langs = Object.entries(data?.languages || {});
  return (
    <section className="ds-card p-5 space-y-4" data-testid="external-templates-panel">
      <div>
        <h3 className="font-display font-bold text-lg">Plantillas automáticas (reserva, post-reparación, recordatorios)</h3>
        <p className="text-xs text-[#525252] mt-1">
          Estas plantillas viven en sus propios paneles y se traducen automáticamente al guardarlas. Usa este panel para generar las traducciones que falten; los envíos nunca llaman a OpenAI.
        </p>
      </div>
      {!data ? <div className="text-xs text-[#525252]">Cargando…</div> : langs.length === 0 ? (
        <div className="text-xs text-[#525252]">No hay idiomas activos además del maestro.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {langs.map(([code, l]) => (
            <div key={code} className="border border-[#E5E5E0] bg-white p-3 space-y-2" data-testid={`external-lang-${code}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="font-mono text-xs uppercase tracking-wider">{shortLang(code)} <span className="text-[#525252] normal-case tracking-normal">· {l.name}</span></div>
                <button onClick={() => translate(code)} disabled={!!busy || l.pending === 0} data-testid={`external-translate-${code}`}
                  className="inline-flex items-center gap-1 border border-[#111110] px-2 py-1 text-[11px] font-mono uppercase hover:bg-[#111110] hover:text-white disabled:opacity-50">
                  {busy === code ? <RefreshCw size={11} className="animate-spin" /> : <Sparkles size={11} />}
                  {l.pending === 0 ? "Al día" : `Traducir ${l.pending} pendiente(s)`}
                </button>
              </div>
              <ul className="space-y-1">
                {l.items.map((it, i) => (
                  <li key={i} className="flex items-center justify-between text-xs">
                    <span>{it.label}</span>
                    <LangStatusIcon st={it} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
